/* CARD-SLIDE-01 (owner 2026-10-08): the card's price row slides sideways to its offer and back. One delegated listener;
   opening one card's offer slides any other back; Escape slides back. Focus moves with the pane for keyboard users. */
(function () {
  'use strict';
  if (window.__szCardSlide) return; window.__szCardSlide = true;
  var open = null;
  function set(slide, on, focus) {
    if (!slide) return;
    slide.classList.toggle('is-offer', on);
    slide.scrollLeft = 0; /* focus must never scroll the clipped row; the track's transform does the sliding */
    /* CARD-ADD-1014: the offer link now sits on the line above the slide (the price row holds the Add pill) */
    var body = slide.closest('.product-body');
    var go = slide.querySelector('[data-card-slide-go]') || (body && body.querySelector('[data-card-slide-go]')), back = slide.querySelector('[data-card-slide-back]'), offer = slide.querySelector('.card-slide__pane--offer'), price = slide.querySelector('.card-slide__pane--price');
    if (go) { go.setAttribute('aria-expanded', on ? 'true' : 'false'); go.tabIndex = on ? -1 : 0; }
    if (back) back.tabIndex = on ? 0 : -1;
    if (offer) offer.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (price) { price.setAttribute('aria-hidden', on ? 'true' : 'false'); price.inert = on; }
    if (focus) { var t = on ? back : go; if (t) setTimeout(function () { t.focus({ preventScroll: true }); slide.scrollLeft = 0; }, 60); }
    open = on ? slide : (open === slide ? null : open);
  }
  document.addEventListener('click', function (e) {
    var go = e.target.closest('[data-card-slide-go]');
    if (go) { var s = go.closest('[data-card-slide]') || (go.closest('.product-body') && go.closest('.product-body').querySelector('[data-card-slide]')); if (open && open !== s) set(open, false); set(s, true, e.detail === 0); return; }
    var back = e.target.closest('[data-card-slide-back]');
    if (back) { set(back.closest('[data-card-slide]'), false, e.detail === 0); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) set(open, false, true); });
})();

/* PERF-01: endless animations (finder tank, shimmer headings) only run while on screen. */
(function () {
  'use strict';
  var els = document.querySelectorAll('.sz-pm-dial, .sz-pm-shimmer'); if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-onscreen'); }); return; }
  var io = new IntersectionObserver(function (list) { list.forEach(function (e) { e.target.classList.toggle('is-onscreen', e.isIntersecting); }); }, { rootMargin: '100px 0px' });
  els.forEach(function (el) { io.observe(el); });
})();

/* CARD-ADD-1014 (owner 2026-10-14: layout C, small pill beside the price; livestock gets the - n + counter, everything
   else reads "Added" while it is in the bag). Cards: snippets/sz-pm-card.liquid form[data-sz-card-add].
   One /cart.js read on load (only when the bag is not empty), then every change answers with the full cart. The counter
   is optimistic: taps update the number at once and one /cart/change.js goes out 400 ms after the last tap. After every
   change the header count, the free-shipping band and an open bag panel repaint (szRdSyncCart + sz:cart-updated). */
(function () {
  'use strict';
  if (window.__szCardAdd) return; window.__szCardAdd = true;
  var lines = {};          /* variant id -> { key, qty } from the latest cart (plain lines only) */
  var known = false;       /* have we seen the cart yet */
  var pending = {};        /* variant id -> { qty, timer, busy } while the counter is being tapped */
  var json = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function forms() { return document.querySelectorAll('form[data-sz-card-add]'); }
  function money(v, type) { return type === 'fixed' ? '$' + v : v + '%'; }
  function tiersOf(f) {
    return (f.getAttribute('data-tiers') || '').split('|').filter(Boolean).map(function (t) {
      var p = t.split(':'); return { q: Number(p[0]) || 0, v: p[1], type: p[2] };
    }).filter(function (t) { return t.q > 0; }).sort(function (a, b) { return a.q - b.q; });
  }
  function nudgeText(f, q) {
    var max = Number(f.getAttribute('data-max')) || 0;
    if (max && q >= max) return 'That’s all ' + max + ' we have';
    var ts = tiersOf(f); if (!ts.length) return '';
    var next = ts.filter(function (t) { return t.q > q; })[0];
    if (next) return 'Add ' + (next.q - q) + ' more to save ' + money(next.v, next.type);
    var top = ts[ts.length - 1];
    return 'Saving ' + money(top.v, top.type);
  }
  function qtyOf(id) { var p = pending[id]; if (p && p.qty != null) return p.qty; return lines[id] ? lines[id].qty : 0; }

  function paint() {
    forms().forEach(function (f) {
      var id = f.getAttribute('data-variant-id'), kind = f.getAttribute('data-sz-card-add');
      var q = qtyOf(id), name = f.getAttribute('data-name') || 'this';
      var btn = f.querySelector('[data-sz-card-add-btn]');
      if (kind === 'item') {
        f.toggleAttribute('data-in', q > 0);
        if (btn) btn.setAttribute('aria-label', q > 0 ? name + ' is in your bag. Open the bag' : 'Add ' + name + ' to bag');
        return;
      }
      var box = f.querySelector('[data-sz-card-qty]'), n = f.querySelector('[data-sz-card-n]');
      var body = f.closest('.product-body');
      var nudge = body && body.querySelector('[data-sz-card-nudge]'), offer = body && body.querySelector('.card-offer');
      if (btn) btn.hidden = q > 0;
      if (box) box.hidden = !(q > 0);
      if (n) n.textContent = q;
      var inc = f.querySelector('[data-sz-card-inc]'), max = Number(f.getAttribute('data-max')) || 0;
      if (inc) inc.disabled = !!(max && q >= max);
      var say = q > 0 ? nudgeText(f, q) : '';
      if (nudge) { nudge.textContent = say; nudge.hidden = !say; }
      if (offer) offer.hidden = !!say;
    });
  }
  function take(cart, fromCard) {
    if (!cart || !cart.items) return;
    lines = {};
    cart.items.forEach(function (li) {
      if (li.selling_plan_allocation) return;
      var k = String(li.variant_id);
      /* QUICK-BUY-01: Buy X get Y splits one grade into a paid and a free line; the counter shows them together and
         changes go to the first line (first = that line's own quantity) */
      if (!lines[k]) lines[k] = { key: li.key, qty: li.quantity, first: li.quantity };
      else lines[k].qty += li.quantity;
    });
    known = true;
    paint();
    toastFromCart(cart);
    if (fromCard) {
      if (window.szRdSyncCart) window.szRdSyncCart();
      document.dispatchEvent(new CustomEvent('sz:cart-updated', { detail: { cart: cart, source: 'card' } }));
    }
  }
  function read() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (c) { if (c) take(c, false); return c; })
      .catch(function () { return null; });
  }
  function flash(f, text) {
    var body = f.closest('.product-body'), nudge = body && body.querySelector('[data-sz-card-nudge]');
    if (!nudge) return;
    nudge.textContent = text; nudge.hidden = false;
    var offer = body.querySelector('.card-offer'); if (offer) offer.hidden = true;
    setTimeout(paint, 2600);
  }
  function busy(f, on) { f.classList.toggle('is-busy', on); if (on) f.setAttribute('aria-busy', 'true'); else f.removeAttribute('aria-busy'); }

  /* CARD-FASTADD-1015 (owner: "the +add take a while to load on mobile"): measured 0.8 s for /cart/add.js (Shopify runs the
     discount Functions on every bag change) plus 0.3 s for a second /cart.js, all before the card changed; longer on 4G.
     Now the card and the header count change on the tap; /cart/add.js's own reply (line key + quantity) is enough to carry
     on, and the full bag is read once in the background for the count, the free-shipping band and an open bag panel. A
     failed add puts everything back and says why. */
  function bumpBadge(d) {
    document.querySelectorAll('[data-sz-rd-cart-count]').forEach(function (el) {
      var n = Math.max(0, (parseInt(el.textContent, 10) || 0) + d);
      el.textContent = n; el.toggleAttribute('data-empty', n === 0);
    });
  }
  var settleTimer = 0;
  function settle() {
    clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c) return;
          take(c, false);
          if (window.szRdSyncCart) window.szRdSyncCart();
          document.dispatchEvent(new CustomEvent('sz:cart-updated', { detail: { cart: c, source: 'card' } }));
        }).catch(function () {});
    }, 150);
  }
  /* CARD-TOAST-1015 (owner 2026-10-15 "cart added and total for that product pop up that is gone after few seconds ...
     make it 2 seconds"): a small dark pop-up, "In your bag / Pink Steel x 3 / $71.25 (saving $3.75)" + View bag. Phones:
     full width just above the bottom menu bar (or the product page buy bar); desktop: bottom right. Gone 2 s after the
     last tap (hover pauses it). The total is worked out from the card's own price and bulk steps at once, then replaced
     by Shopify's real line total when the background bag read lands. No extra request. */
  var toastEl = null, toastTimer = 0, toastId = null, toastKeep = false;
  function fmt(c) { var d = (Number(c) || 0) / 100; return '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0)); }
  function estimate(f, q) {
    var price = Number(f.getAttribute('data-price')) || 0, best = null;
    tiersOf(f).forEach(function (t) { if (q >= t.q) best = t; });
    var total = price * q;
    /* QUICK-BUY-01: a card in a pay-for-some, get-some-free deal (data-buy / data-get) pays for buy of every full set */
    var bb = Number(f.getAttribute('data-buy')) || 0, bg = Number(f.getAttribute('data-get')) || 0;
    if (bb > 0 && bg > 0) { total = price * (q - Math.floor(q / (bb + bg)) * bg); return { total: total, saved: price * q - total }; }
    if (best) total = best.type === 'fixed' ? Math.max(0, (price - Number(best.v) * 100) * q) : Math.round(price * q * (100 - Number(best.v)) / 100);
    return { total: total, saved: price * q - total };
  }
  function hideToast() {
    clearTimeout(toastTimer);
    if (toastEl) toastEl.classList.remove('is-on', 'is-run');
    toastId = null;
  }
  function armToast() {
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 2000);
    toastEl.classList.remove('is-run'); void toastEl.offsetWidth; toastEl.classList.add('is-run');
  }
  function toastNode() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'sz-cardtoast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    toastEl.innerHTML = '<span class="sz-cardtoast__img" aria-hidden="true"></span>' +
      '<span class="sz-cardtoast__txt"><span class="sz-cardtoast__k">In your bag</span><b class="sz-cardtoast__name"></b><span class="sz-cardtoast__sum"></span></span>' +
      '<button type="button" class="sz-cardtoast__go">View bag</button><span class="sz-cardtoast__bar" aria-hidden="true"></span>';
    toastEl.querySelector('.sz-cardtoast__go').addEventListener('click', function () {
      hideToast();
      if (window.szRdCartQuickView) window.szRdCartQuickView.open(); else window.location.href = '/cart';
    });
    toastEl.addEventListener('mouseenter', function () { clearTimeout(toastTimer); toastEl.classList.remove('is-run'); });
    toastEl.addEventListener('mouseleave', function () { if (toastEl.classList.contains('is-on')) armToast(); });
    document.body.appendChild(toastEl);
    /* the bottom menu bar slides with scrolling: keep the pop-up just above it while it shows */
    window.addEventListener('scroll', function () { if (toastEl.classList.contains('is-on')) placeToast(); }, { passive: true });
    return toastEl;
  }
  function placeToast() {
    var b = 0, vh = window.innerHeight;
    ['.sz-rd-tabbar', '.sz-pm-buybar'].forEach(function (sel) {
      var n = document.querySelector(sel); if (!n) return;
      var r = n.getBoundingClientRect();
      if (r.height > 0 && r.top < vh - 1 && r.bottom > vh - 4 && getComputedStyle(n).visibility !== 'hidden') b = Math.max(b, vh - r.top);
    });
    toastEl.style.bottom = b > 0 ? (b + 10) + 'px' : '';
  }
  function sumText(total, saved) { return fmt(total) + (saved > 0 ? ' (saving ' + fmt(saved) + ')' : ''); }
  function showToast(f, q) {
    if (!(q > 0)) { hideToast(); return; }
    var el = toastNode();
    toastId = f.getAttribute('data-variant-id');
    toastKeep = f.hasAttribute('data-buy');
    var img = el.querySelector('.sz-cardtoast__img'), src = f.getAttribute('data-img');
    img.style.backgroundImage = src ? 'url("' + src.replace(/"/g, '') + '")' : '';
    img.classList.toggle('is-empty', !src);
    el.querySelector('.sz-cardtoast__name').textContent = (f.getAttribute('data-name') || 'Item') + ' \u00d7 ' + q;
    var e = estimate(f, q);
    el.querySelector('.sz-cardtoast__sum').textContent = sumText(e.total, e.saved);
    placeToast();
    el.classList.add('is-on');
    armToast();
  }
  /* QUICK-BUY-01: the quick-buy panel (assets/sz-rd-qv.js) shows the same pop-up after its Add.
     o = { id, name, qty, img, total, saved } (cents) */
  window.szCardToast = function (o) {
    if (!o || !(o.qty > 0)) return;
    var el = toastNode();
    toastId = String(o.id); toastKeep = o.saved > 0;
    var img = el.querySelector('.sz-cardtoast__img');
    img.style.backgroundImage = o.img ? 'url("' + String(o.img).replace(/"/g, '') + '")' : '';
    img.classList.toggle('is-empty', !o.img);
    el.querySelector('.sz-cardtoast__name').textContent = (o.name || 'Item') + ' \u00d7 ' + o.qty;
    el.querySelector('.sz-cardtoast__sum').textContent = sumText(o.total, o.saved);
    placeToast();
    el.classList.add('is-on');
    armToast();
  };
  function toastFromCart(cart) {
    if (!toastEl || !toastId || !toastEl.classList.contains('is-on') || !cart || !cart.items) return;
    if (pending[toastId] && pending[toastId].qty != null) return; /* more taps still on the way: keep the estimate */
    /* QUICK-BUY-01: a deal's saving is not in the line total (the deal is an order discount, or Buy X get Y splits the line),
       so the worked-out figure stays */
    if (toastKeep) return;
    var li = cart.items.filter(function (x) { return String(x.variant_id) === String(toastId) && !x.selling_plan_allocation; })[0];
    if (!li) return;
    var name = toastEl.querySelector('.sz-cardtoast__name').textContent.replace(/ \u00d7 \d+$/, '');
    toastEl.querySelector('.sz-cardtoast__name').textContent = name + ' \u00d7 ' + li.quantity;
    toastEl.querySelector('.sz-cardtoast__sum').textContent = sumText(li.final_line_price, li.original_line_price - li.final_line_price);
  }
  function addOne(f) {
    var id = f.getAttribute('data-variant-id');
    var p = pending[id] || (pending[id] = { qty: null, timer: 0, busy: false });
    if (p.busy) return;
    p.busy = true; p.qty = 1;
    f.setAttribute('aria-busy', 'true');
    paint(); bumpBadge(1); showToast(f, 1);
    return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) {
        if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { throw e; });
        return r.json();
      })
      .then(function (res) {
        var it = res && res.items && res.items[0];
        if (it) lines[id] = { key: it.key, qty: it.quantity };
        known = true;
        p.busy = false; f.removeAttribute('aria-busy');
        if (p.qty === 1 || p.qty == null) { delete pending[id]; paint(); settle(); }
        else commit(f); /* the shopper kept tapping + while the add was on the wire */
      })
      .catch(function (e) {
        delete pending[id]; f.removeAttribute('aria-busy');
        bumpBadge(-1); paint(); hideToast();
        flash(f, (e && e.description) || 'Could not add this. Please try again.');
        read();
      });
  }
  function commit(f) {
    var id = f.getAttribute('data-variant-id'), p = pending[id];
    if (!p || p.busy) return;
    var want = p.qty, line = lines[id];
    p.busy = true; busy(f, true);
    var req = line
      ? fetch('/cart/change.js', { method: 'POST', headers: json, body: JSON.stringify({ id: line.key, quantity: Math.max(0, (line.first != null ? line.first : line.qty) + want - line.qty) }) })
      : fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: Number(id), quantity: want }] }) });
    req.then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { throw e; });
      return line ? r.json() : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (c) { return c.json(); });
    })
      .then(function (cart) {
        p.busy = false;
        if (p.qty === want) delete pending[id];
        take(cart, true);
        if (pending[id]) commit(f); /* more taps landed while this one was on the wire */
      })
      .catch(function (e) {
        delete pending[id];
        read().then(function () { flash(f, (e && e.description) || 'Could not change this. Please try again.'); });
      })
      .then(function () { busy(f, false); });
  }
  function step(f, d) {
    var id = f.getAttribute('data-variant-id'), max = Number(f.getAttribute('data-max')) || 0;
    var q = Math.max(0, qtyOf(id) + d);
    if (max) q = Math.min(max, q);
    if (q > 99) q = 99;
    var p = pending[id] || (pending[id] = { qty: null, timer: 0, busy: false });
    p.qty = q;
    paint();
    showToast(f, q);
    clearTimeout(p.timer);
    p.timer = setTimeout(function () { commit(f); }, 400);
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-sz-card-add]');
    if (!f) return;
    e.preventDefault();
    if (f.classList.contains('is-busy')) return;
    var id = f.getAttribute('data-variant-id');
    if (f.getAttribute('data-sz-card-add') === 'item' && qtyOf(id) > 0) {
      if (window.szRdCartQuickView) window.szRdCartQuickView.open(f.querySelector('[data-sz-card-add-btn]'));
      else window.location.href = '/cart';
      return;
    }
    addOne(f);
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-sz-card-inc], [data-sz-card-dec]');
    if (!t) return;
    var f = t.closest('form[data-sz-card-add]'); if (!f) return;
    e.preventDefault();
    step(f, t.hasAttribute('data-sz-card-inc') ? 1 : -1);
  });
  /* the bag panel, the PDP and sync change the bag too: keep the cards honest */
  document.addEventListener('sz:cart-updated', function (e) { var d = e.detail || {}; if (d.source !== 'card' && d.cart) take(d.cart, false); });
  document.addEventListener('sz-rd:added', function () { if (forms().length) read(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted && forms().length) read(); });
  /* cards added later (load more, filters) pick up the bag state */
  if ('MutationObserver' in window) {
    var t = 0;
    new MutationObserver(function (recs) {
      if (!known) return;
      /* only new cards matter; paint() itself edits text, so never repaint on our own changes (that would loop) */
      var hit = recs.some(function (r) {
        for (var i = 0; i < r.addedNodes.length; i++) {
          var n = r.addedNodes[i];
          if (n.nodeType === 1 && (n.matches('form[data-sz-card-add]') || n.querySelector('form[data-sz-card-add]'))) return true;
        }
        return false;
      });
      if (hit) { clearTimeout(t); t = setTimeout(paint, 60); }
    })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
  function start() {
    if (!forms().length) return;
    var badge = document.querySelector('[data-sz-rd-cart-count]');
    if (badge && Number(badge.textContent) === 0) { known = true; return; }
    read();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
